import { render, staticRenderFns } from "./ResetSecurityProfileOTPSummary.vue?vue&type=template&id=29f8a595&scoped=true"
import script from "./ResetSecurityProfileOTPSummary.vue?vue&type=script&lang=js"
export * from "./ResetSecurityProfileOTPSummary.vue?vue&type=script&lang=js"
import style0 from "./ResetSecurityProfileOTPSummary.vue?vue&type=style&index=0&id=29f8a595&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f8a595",
  null
  
)

export default component.exports